import React from 'react';
import { DesignMode, DesignSettings, useNode } from '@mnz/builder';
import { useTheme, alpha } from '@mui/material';
import ShareButton from './ShareButton';
import StyledComponent from '../../core/StyledComponent';
import { px2rem } from '../../core';
import { Share } from '@menuzen/icon/build/outline';

interface BaseHeaderProps {
    isLiveMode: boolean;
    designSettings: DesignSettings;
}

const BaseHeader: React.FC<BaseHeaderProps> = ({ designSettings, isLiveMode }) => {
    const theme = useTheme();
    const {
        query: { getOptions },
    } = useNode();
    const disabled = getOptions().enabled;
    if (disabled) {
        return null;
    }

    return (
        <StyledComponent
            xs={{
                padding: `${px2rem(20)} ${px2rem(20)} 0`,
                display: 'flex',
                alignItem: 'center',
                justifyContent: 'end',
                fontFamily: theme.typography.fontFamily,
                top: 0,
                right: 0,
                position: 'absolute',
                zIndex: 10,
            }}
        >
            <StyledComponent
                xs={{
                    display: 'flex',
                    alignItems: 'stretch',
                    justifyContent: 'end',
                }}
            >
                {getOptions().mode === DesignMode.LIVE && (
                    <ShareButton isLiveMode={isLiveMode} designSettings={designSettings}>
                        <StyledComponent
                            xs={{
                                padding: `${px2rem(6)} ${px2rem(10)}`,
                                display: 'flex',
                                alignItems: 'center',
                                color: 'white',
                                borderRadius: `${px2rem(5)}`,
                                fontSize: px2rem(12),
                                background: alpha(theme.palette.primary.main, 0.6),
                            }}
                        >
                            <Share />
                            <StyledComponent xs={{ fontSize: px2rem(12), fontWeight: 600, marginLeft: px2rem(4) }}>
                                Share
                            </StyledComponent>
                        </StyledComponent>
                    </ShareButton>
                )}
            </StyledComponent>
        </StyledComponent>
    );
};

export default BaseHeader;
